import TextFieldsIcon from '@mui/icons-material/TextFields'
import NumbersIcon from '@mui/icons-material/Numbers'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import ChecklistIcon from '@mui/icons-material/Checklist'
import type { SvgIconProps } from '@mui/material'
import type { PropertyType } from '@/object-types/gql/PropertyType.ts'

export function iconForType(
  propType: PropertyType,
  fontSize: SvgIconProps['fontSize'] = 'medium',
): React.ReactElement {
  switch (propType) {
    case 'text':
      return <TextFieldsIcon fontSize={fontSize} />
    case 'number':
      return <NumbersIcon fontSize={fontSize} />
    case 'date':
      return <CalendarTodayIcon fontSize={fontSize} />
    case 'toggle':
      return <ToggleOnIcon fontSize={fontSize} />
    case 'select-1':
      return <RadioButtonCheckedIcon fontSize={fontSize} />
    case 'multi-select':
      return <ChecklistIcon fontSize={fontSize} />
  }
}
